module.exports = __webpack_public_path__ + "static/media/Humdrum Life (ft Inbar Livne).7a2cc0d6.jpg";